import { render, staticRenderFns } from "./ByApp.vue?vue&type=template&id=49aa8ded&scoped=true"
import script from "./ByApp.vue?vue&type=script&lang=js"
export * from "./ByApp.vue?vue&type=script&lang=js"
import style0 from "./ByApp.vue?vue&type=style&index=0&id=49aa8ded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa8ded",
  null
  
)

export default component.exports